import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { SET_ERROR, SET_ERROR_VISIBLE, TErrorAction } from '../actions/errorActions';
import { TAction } from '../actions/types/action';

export default function errorReducer(state: Partial<TErrorAction> = {}, action: TAction<any>): any {
  switch (action.type) {
    case SET_ERROR: {
      return {
        ...state,
        ...action.payload,
        visible: true
      };
    }
    case SET_ERROR_VISIBLE: {
      return {
        ...state,
        visible: action.payload
      };
    }
    case LOCATION_CHANGE: {
      return {};
    }
    default:
      return state;
  }
}
